export default {"src":"/login-app/[GIT_HASH]/_next/static/media/file_sql.5f2f621b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};